import type { CurrentEmployee } from '@heltarchat/shared';
import api from 'app/api';

export const fetchCurrentEmployee = async (
  email: string,
): Promise<CurrentEmployee | null> => {
  const response = await api.get(`/auth/business-employees/${email}`);
  return response?.data?.data || null;
};
